import { Trophy, RefreshCw } from 'lucide-react';

export default function IncorrectAnswer({ totalScore }) {
  return (
    <div className="relative flex flex-col h-screen w-full mx-auto max-w-md bg-mp-bg-pink font-body text-mp-darkgreen overflow-hidden">
      {/* Header */}
      <header className="relative z-10 flex items-center justify-between p-6">
        <span className="mp-eyebrow">Mikkel kviss · Deltakar</span>
        <div className="w-10" />
      </header>

      {/* Main */}
      <main className="relative z-10 flex flex-1 flex-col items-center justify-center text-center px-6 -mt-6">
        <img
          src="/Mikkel tenker uten bakgrunn.png"
          alt=""
          className="w-[160px] h-auto mb-5 -rotate-6"
        />
        <h1 className="font-display text-mp-darkgreen text-[40px] leading-tight mb-2">
          Ikkje denne gongen
        </h1>
        <p className="font-display text-mp-stone-700 text-[16px] mb-3">
          Du fekk <span className="text-mp-magenta">+ 0</span> poeng
        </p>
        <p className="font-body text-mp-stone-700 text-[15px] max-w-[300px] mb-7">
          Ingen ting å vere lei seg for — Mikkel og me andre held fram.
        </p>

        <div className="inline-flex items-center gap-2 bg-white/70 px-4 py-2.5 rounded-full font-display text-mp-darkgreen border border-[rgba(17,73,66,0.12)] shadow-mp-1">
          <Trophy size={16} className="text-mp-fox-rust" />
          Totalpoeng: <strong className="text-mp-teal">{totalScore?.toLocaleString() || 0}</strong>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 w-full px-6 pb-10">
        <div className="flex items-center justify-center gap-2 mb-2">
          <RefreshCw size={14} className="text-mp-darkgreen/70 animate-spin" />
          <p className="font-display text-mp-darkgreen/70 text-[11px] uppercase tracking-[0.18em]">
            Neste spørsmål kjem snart …
          </p>
        </div>
        <div className="rounded-full bg-mp-darkgreen/10 h-2 w-full overflow-hidden">
          <div className="h-2 rounded-full bg-mp-magenta w-2/3 animate-pulse" />
        </div>
      </footer>
    </div>
  );
}
